import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router';

import withMessages from 'component-utilities/intl';

import Layout from '../../global/components/Layout';
import HeadlineLabel from '../../global/components/HeadlineLabel';
import Breadcrumb from '../../global/components/Breadcrumb';

import validateSettingsAccess from './components/validateSettingsAccess';

import SearchListForm from './SearchLists/SearchListForm';

import {
  loadSearchLists,
  createSearchList,
} from '../../global/state_managers/SearchListsStateManager';
import { breadcrumbsActions } from '../../global/state_managers/BreadcrumbsStateManager';
import { SearchList } from 'global/types';

const mapStateToProps = ({ searchLists }: any) => ({
  searchLists: searchLists.searchLists,
});

const mapActionsToProps = {
  loadSearchLists,
  createSearchList,
  setBreadcrumbForSearchListsNewListPage:
    breadcrumbsActions.settingsSearchListsNewListPage,
};

type Props = {
  setBreadcrumbForSearchListsNewListPage: Function,
  createSearchList: Function,
  getMessage: Function,
  searchLists: SearchList[],
  loadSearchLists: Function
};

function NewSearchListComponent(props: Props) {
  // Route param from the URL (settings/search-lists/new/:type). React Router
  // renders page components through <Outlet/> without injecting params as props,
  // so this must come from useParams() — the old `routeParams` prop was a
  // react-router v3 leftover that is now undefined (missed in the migration).
  const { type } = useParams();

  useEffect(() => {
    props.setBreadcrumbForSearchListsNewListPage();
  }, []);

  const onSave = useCallback((data: any) => props.createSearchList(type, data), [props.createSearchList, type]);

  const { getMessage, searchLists } = props;

  return (
    <Layout section="settings search-lists new">
      <header>
        <Breadcrumb />
        <HeadlineLabel text={getMessage('app.breadcrumb.new_list')} />
      </header>
      <SearchListForm
        onSave={onSave}
        currentLists={searchLists}
        loadSearchLists={props.loadSearchLists}
      />
    </Layout>
  );
}

NewSearchListComponent.propTypes = {
  getMessage: PropTypes.func.isRequired,
  searchLists: PropTypes.array.isRequired,
  loadSearchLists: PropTypes.func.isRequired,
  createSearchList: PropTypes.func.isRequired,
  setBreadcrumbForSearchListsNewListPage: PropTypes.func.isRequired,
};

const withMessagesComponent = withMessages(NewSearchListComponent);
const connectedComponent = connect(
  mapStateToProps,
  mapActionsToProps,
)(withMessagesComponent);
const NewSearchList = validateSettingsAccess('settings.search_lists')(connectedComponent);

export default NewSearchList;
